import { FC } from "react";

const Search: FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_247)">
        <path
          d="M29 27.5859L21.4479 20.0338C23.2626 17.8552 24.1675 15.0608 23.9744 12.2319C23.7813 9.40306 22.505 6.75757 20.4111 4.84576C18.3171 2.93396 15.5667 1.90303 12.732 1.96745C9.8973 2.03186 7.19656 3.18666 5.19161 5.19161C3.18666 7.19656 2.03186 9.8973 1.96745 12.732C1.90303 15.5667 2.93396 18.3171 4.84576 20.4111C6.75757 22.505 9.40306 23.7813 12.2319 23.9744C15.0608 24.1675 17.8552 23.2626 20.0338 21.4479L27.5859 29L29 27.5859ZM3.99999 13C3.99999 11.22 4.52783 9.4799 5.51677 7.99986C6.5057 6.51982 7.91131 5.36627 9.55584 4.68508C11.2004 4.00389 13.01 3.82566 14.7558 4.17292C16.5016 4.52019 18.1053 5.37736 19.364 6.63603C20.6226 7.8947 21.4798 9.49835 21.8271 11.2442C22.1743 12.99 21.9961 14.7996 21.3149 16.4441C20.6337 18.0887 19.4802 19.4943 18.0001 20.4832C16.5201 21.4722 14.78 22 13 22C10.6139 21.9973 8.32621 21.0483 6.63895 19.361C4.9517 17.6738 4.00264 15.3861 3.99999 13Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_247">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Search;
